import React from 'react';
import { Portal as TooltipPortal } from '@radix-ui/react-tooltip';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@dashboard/components/ui/tooltip';

// The span carries the tooltip's data-state, which would otherwise replace a toggle's own, and keeps
// the tooltip on a disabled button. The portal matters: the composer is a size container, which would
// pin a fixed tooltip to itself, and the chat's scroll area would clip it.
export default function PanelTooltip({ label, children }) {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex">{children}</span>
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent side="top" className="px-2 py-1 text-xs">
            {label}
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>
    </TooltipProvider>
  );
}
